'use client';

import type React from 'react';
import { useMemo } from 'react';
import {
  PageFunctionControllerContext,
  type PageFunctionControllerContextType,
} from './PageFunctionControllerContext';

/**
 * PageFunctionController can't directly import stores because it needs to work with different
 * store implementations (GlobalStateStore vs GlobalAppStateStore) in different contexts.
 *
 * This provider injects all needed functions, actions, and reactive variables through context
 * so the controller stays adaptable. Components use selectors (useContextSelector) for
 * fine-grained reactivity and optimal re-renders.
 */
export function PageFunctionControllerProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: PageFunctionControllerContextType;
}) {
  const contextValue = useMemo(() => value, [value]);

  return (
    <PageFunctionControllerContext.Provider value={contextValue}>
      {children}
    </PageFunctionControllerContext.Provider>
  );
}
